module.exports = new __parcel__URL__("cat.154e1595.svg").toString();